import PageTitle from './../../../components/partials/PageTitle'
import OfficeTable from '../../../components/tables/admin/OfficeTable'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'


const OfficeList = () => {

  const { user_permissions } = useSelector((state) => state.auth?.user);

  const navigate = useNavigate();
 
  const breadcrumb = {
    'from': {
        'title': 'Office',
        'link': '/admin/office-list'
    },
    'current': {
        'title': 'office list',
        'link': null
    }
  }

  useEffect(() => {
    if (!user_permissions?.some(permission => permission.name === 'office module')) {
      navigate('/admin/dashboard')
    }
  }, [navigate, user_permissions])

  return (
    <>
        {/* page title */}
         <PageTitle title='Office List' breadcrumb={breadcrumb}/>
        {/* end page title */}

          <OfficeTable/>
    </>
  )
}

export default OfficeList